module.exports = __webpack_public_path__ + "static/img/av.6340d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/media/av.jpg
// module id = v1mG
// module chunks = 1